import { motion } from 'framer-motion';
// import { useState } from 'react';

import { useIsDesktop } from '../../hooks/useIsDesktop';
// import { Paginator } from '../Paginator';

import { ItemAssistant } from './ItemsAssistant';

import { EquipoZona } from '@/types/fieldAssistance';
import { VariantFieldAssistance } from '@/types/team';
import { FADE_IN_OUT, cn } from '@/utils';

interface Props extends VariantFieldAssistance {
  teams: EquipoZona[];
}

export const PositionTable = ({ teams, variant = 'DEFAULT' }: Props) => {
  const { isMobile } = useIsDesktop();
  /* const [contentCurrentPage, setContentCurrentPage] = useState<EquipoZona[]>(
    []
  );
  const handleContentCurrentPage = (teams: EquipoZona[]) => {
    teams && setContentCurrentPage(teams);
  }; */

  return (
    teams &&
    teams.length > 0 && (
      <motion.div animate={'show'} initial={'hide'} variants={FADE_IN_OUT}>
        <div
          className={cn('w-full bg-white mt-3 lg:mt-6 rounded-lg', {
            'h-screen': variant === 'EMBED',
          })}
        >
          <div className="flex items-center text-xs font-bold text-gdt-gray-4 h-11 pr-5 lg:pr-[75px]">
            <p className="w-12 lg:w-[70px] text-center lg:ml-[25px]">Pos</p>
            <p className="text-left flex-1 ml-1 lg:ml-0">Equipo</p>
            <div className="flex items-center justify-between lg:max-w-[560px]">
              <p className="lg:w-16 w-9 text-center">
                {isMobile ? 'PTS' : 'Puntos'}
              </p>
              <p className="lg:w-16 w-6 text-center">J</p>
              <p className="lg:w-16 w-6 text-center">G</p>
              <p className="lg:w-16 w-6 text-center">E</p>
              <p className="lg:w-16 w-6 text-center">P</p>
              <p className="lg:w-16 w-6 text-center">GF</p>
              <p className="lg:w-16 w-6 text-center">GC</p>
            </div>
          </div>
          {!isMobile && (
            <>
              {teams.map((team: EquipoZona) => {
                return <ItemAssistant.Positions key={team.id} team={team} />;
              })}
              {/* <Paginator
                currentContentPage={handleContentCurrentPage}
                items={teams}
              /> */}
            </>
          )}
          {isMobile && (
            <div
              className={cn({
                'overflow-auto h-[calc(100vh-220px)]': variant === 'EMBED',
              })}
            >
              {teams.map((team: EquipoZona) => {
                return <ItemAssistant.Positions key={team.id} team={team} />;
              })}
            </div>
          )}
        </div>
      </motion.div>
    )
  );
};
